<template>
    <div class="quick-start-container">
      <div class="quick-start-header">
        <h2 class="title">Start Your Conversation</h2>
        <p class="subtitle">Add content or ask a question to begin</p>
      </div>

      <div class="quick-action-grid">
        <div class="action-card" @click="$emit('open-file-upload')">
          <v-icon size="36" color="primary">mdi-file-document</v-icon>
          <span>Upload Documents</span>
          <p class="action-hint">Import PDFs, DOCs, TXT, etc.</p>
        </div>

        <div class="action-card" @click="$emit('open-submit-text')">
          <v-icon size="36" color="info">mdi-text-box-plus</v-icon>
          <span>Submit Text</span>
          <p class="action-hint">Paste or type content</p>
        </div>

        <div class="action-card" @click="$emit('open-youtube-submit')">
          <v-icon size="36" color="error">mdi-youtube</v-icon>
          <span>YouTube Videos</span>
          <p class="action-hint">Import from video transcripts</p>
        </div>

        <div class="action-card" @click="$emit('open-image-upload')">
          <v-icon size="36" color="success">mdi-image</v-icon>
          <span>Upload Images</span>
          <p class="action-hint">Extract text from images</p>
        </div>

        <div class="action-card primary-action" @click="$emit('start-first-project')">
          <v-icon size="36" color="white">mdi-message-text</v-icon>
          <span>Ask a Question</span>
          <p class="action-hint">Start with a simple question</p>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'QuickStart',
    emits: [
      'start-first-project',
      'open-file-upload',
      'open-submit-text',
      'open-youtube-submit',
      'open-image-upload',
      'show-popular'
    ]
  }
  </script>

  <style scoped>
  .quick-start-container {
    max-width: 900px;
    margin: 40px auto;
    padding: 30px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
    animation: fadeIn 0.5s ease-out;
  }

  .theme--dark .quick-start-container {
    background: rgba(30, 41, 59, 0.95);
    border-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }

  .quick-start-header {
    text-align: center;
    margin-bottom: 40px;
  }

  .title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 8px;
    background: linear-gradient(135deg, #00eaff 0%, #8B5CF6 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .subtitle {
    font-size: 18px;
    color: #6b7280;
  }

  .theme--dark .subtitle {
    color: #d1d5db;
  }

  .quick-action-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 20px;
    margin-bottom: 40px;
  }

  .action-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 24px 16px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
    height: 100%;
  }

  .theme--dark .action-card {
    background: rgba(30, 41, 59, 0.5);
  }

  .action-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }

  .theme--dark .action-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }

  .action-card span {
    font-weight: 600;
    font-size: 16px;
    color: #1f2937;
  }

  .theme--dark .action-card span {
    color: #f9fafb;
  }

  .action-hint {
    font-size: 12px;
    color: #6b7280;
    margin: 0;
  }

  .theme--dark .action-hint {
    color: #9ca3af;
  }

  .primary-action {
    background: linear-gradient(135deg, #00eaff 0%, #8B5CF6 100%);
    color: white;
    grid-column: span 2;
  }

  .primary-action span,
  .primary-action .action-hint {
    color: white;
  }

  .quick-start-footer {
    text-align: center;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 768px) {
    .quick-start-container {
      margin: 20px;
      padding: 20px;
    }

    .quick-action-grid {
      grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
      gap: 16px;
    }

    .title {
      font-size: 26px;
    }

    .subtitle {
      font-size: 16px;
    }

    .primary-action {
      grid-column: auto; /* Don't span on mobile */
    }
  }
  </style>
